var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 41,
    r: 41,
    fill: "#3CD856"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.4838 27.1939L43.7191 28.1603C42.6857 28.3079 41.8413 28.8005 41.2384 29.4813L25.4545 45.2652C23.8534 46.8663 23.8533 49.4622 25.4545 51.0634L31.2528 56.8617C32.854 58.4629 35.4499 58.4629 37.0511 56.8617L52.8349 41.0779C53.5157 40.4749 54.0083 39.6306 54.1559 38.5971L55.1223 31.8324C55.509 29.1267 53.1895 26.8072 50.4838 27.1939ZM45.7485 36.5677C46.549 37.3683 47.847 37.3683 48.6476 36.5677C49.4482 35.7672 49.4481 34.4691 48.6476 33.6686C47.8471 32.8681 46.5491 32.868 45.7485 33.6686C44.9479 34.4692 44.948 35.7672 45.7485 36.5677Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/Icon.eaa1df7ab71f09d3547b52e4a33c9bd1.svg";
export { ForwardRef as ReactComponent };